"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelleone-di-suasa": {
    "8c63ac61": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "skipSearch": false
    }],
    "casalta-bozzo": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eac7674e": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "skipSearch": false
    }],
    "casenuove-farneto": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5db06528": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "skipSearch": false
    }],
    "pianvolpello": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "37b6669f": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia-bozzo": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2811740": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "skipSearch": false
    }],
    "ville": [{
      "hkey": "bea315b8",
      "slug": "castelleone-di-suasa",
      "name": "Castelleone di Suasa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;